<template>
  <div>
    <div class="col-md-12 m-t-sm mobile-m-top-0 mobile-p-left-0 ">
      <div class="col-lg-2 col-md-2 col-xs-2"></div>
      <div class="col-lg-10 col-md-10 col-xs-10 emailed-text p-left-10 mobile-left-8">{{log.username ? log.username : 'System'}} emailed {{log.to}}, {{log.created_time}}</div>
    </div>

    <div class="col-lg-12 col-md-12 col-xs-12 mobile-p-left-0 m-top-10">
      <div class="col-lg-2 col-md-2 col-xs-2">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="#85B6FF"/>
          <g clip-path="url(#clip0_5527_39363)">
            <path d="M30 14C30 12.9 29.1 12 28 12H12C10.9 12 10 12.9 10 14V26C10 27.1 10.9 28 12 28H28C29.1 28 30 27.1 30 26V14ZM28 14L20 19L12 14H28ZM28 26H12V16L20 21L28 16V26Z" fill="#2E4051"/>
          </g>
          <defs>
            <clipPath id="clip0_5527_39363">
              <rect width="24" height="24" fill="white" transform="translate(8 8)"/>
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="col-lg-10 col-md-10 col-xs-10 p-all-10 subject-div mobile-left-8">
        <a href="#" data-toggle="modal" data-target="#popupi" class="details_info_opt" @click="openMailPopupModal(log)">
          {{ log.subject || '(No Subject)' }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EmailLogRow",
  props: {
    log: {
      type: Object,
      required: true,
    }
  },
  methods: {
    openMailPopupModal(mailLog){
      window.popupi('Email',`/email/details/${mailLog.email_log_id}`,'emailDetails');
    }
  }
}
</script>
<style scoped>
.subject-div{
  background-color: rgba(0, 140, 250, 0.15);
  border-radius: 20px;
}
.emailed-text{
    color:rgba(46, 64, 81, 1);
    font-family: Roboto;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
}
.details_info_opt{
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  //line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(0, 140, 250, 1);
}
/* only in this case because the logo is bigger than the col*/
@media (min-width: 767px) and (max-width: 768px) {
  .col-lg-2 {
    width: 9%;
  }
}
@media (max-width: 991px) {
  .mobile-m-top-0 {
    margin-top: 0px;
  }
  .mobile-left-8 {
    left: 8px;
  }
  .mobile-p-left-0 {
    padding-left: 0px;
  }
  .mobile-m-left-44 {
    margin-left: 44px;
  }
}
@media (min-width: 1024px) and (max-width: 1024px) {
  .laptop-xs-left-22 {
    left: 22px;
  }
}
@media  (min-width: 500px) and (max-width: 768px)
{
  .col-xs-2
  {

    width: 11%;
    padding: 0 5px 0 10px;
  }
}


@media (min-width: 768px) and (max-width: 992px) {
  .col-lg-2 {
    width: 12%;
  }
}
@media (min-width: 992px) and (max-width: 1100px) {
  .col-lg-2 {

    width: 16%;
    padding: 0px;
  }

  }
@media (min-width: 1100px) and (max-width: 1260px) {
  .col-lg-2 {
    width: 15%;
  }
}
@media (min-width: 1260px) and (max-width: 1599px) {
  .col-lg-2 {
    width: 12%;
  }
}
@media (min-width: 1600px) and (max-width: 1920px) {
  .col-lg-2 {
    width: 9%;
  }
}
@media (min-width: 1921px)  and (max-width: 2200px) {
  .col-lg-2 {
    width: 8%;
  }
}
@media (min-width: 2200px)  {
  .col-lg-2 {
    width: 6%;
  }
}
</style>